import './InsightCard.scss';

export const InsightCard = ({ insight, onClick }) => {
  return (
    <div className="insight-card" onClick={() => onClick(insight)}>
      <img src={insight.imageUrl} alt="InsightIcon" />
      <div className="insight-title">{insight.title}</div>
      <div className="read-more"> Read More...</div>
    </div>
  );
};
